/**
 * `GET /me/standing-call-link` as `queryOptions` — ONE cache entry for `/konto`'s Integracje row and
 * `/rezerwacje`'s create panel, which prefills it. Outside both screens' prefixes, so neither's
 * writes re-read it by accident.
 */

import { queryOptions } from '@tanstack/react-query';

import { getMeStandingCallLink } from '~/shared/api/generated/endpoints/my-standing-call-link/my-standing-call-link';

export const standingCallLinkQueryKey = ['standing-call-link'] as const;

export function standingCallLinkQueryOptions() {
  return queryOptions({
    queryKey: standingCallLinkQueryKey,
    queryFn: ({ signal }) => getMeStandingCallLink(undefined, signal),
  });
}
